"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var styled_components_1 = __importStar(require("styled-components"));
var styled_system_1 = require("styled-system");
exports.align = function (props) { return (props.align ? { textAlign: props.align } : null); };
exports.bold = function (props) {
    return props.bold ? { fontWeight: props.theme.fontWeights.bold } : null;
};
exports.bolder = function (props) {
    return props.bolder ? { fontWeight: props.theme.fontWeights.bolder } : null;
};
exports.caps = function (props) {
    return props.caps
        ? {
            textTransform: 'uppercase',
            letterSpacing: styled_system_1.themeGet('letterSpacings.caps')
        }
        : null;
};
exports.small = function (props) {
    return props.small
        ? styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        font-size: ", "px;\n\n        ", " {\n          font-size: ", "px;\n        }\n      "], ["\n        font-size: ", "px;\n\n        ", " {\n          font-size: ", "px;\n        }\n      "])), props.theme.fontSizes[0], props.theme.mediaQueries.md, props.theme.fontSizes[1]) : null;
};
var fullWidth = function (props) { return (props.fullWidth ? { width: '100%' } : undefined); };
var Text = styled_components_1["default"].p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  font-family: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), styled_system_1.themeGet('textFont'), exports.align, exports.bold, exports.bolder, exports.caps, exports.small, fullWidth, styled_system_1.color, styled_system_1.fontSize, styled_system_1.fontWeight, styled_system_1.lineHeight, styled_system_1.space, styled_system_1.maxWidth);
Text.defaultProps = {
    bold: false,
    caps: false,
    fullWidth: false,
    lineHeight: 'standard'
};
exports["default"] = Text;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Text.js.map